module.exports = __webpack_public_path__ + "static/img/btn-satisfaction-1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/btn-satisfaction-1.png
// module id = 518
// module chunks = 0